import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
// import "./Spinner.css";

let load = false;
let hidingPromises: any[] = [];

export const changeShowLoading = async (
  showSpinner: Promise<void | boolean>
) => {
  load = true;

  if (showSpinner) {
    hidingPromises.push(showSpinner);
    await showSpinner.finally(() => {
      hidingPromises.pop();
      if (hidingPromises.length === 0) {
        load = false;
      }
    });
    return showSpinner;
  }
};

export const hideLoading = () => {
  load = false;
};

export const showLoading = () => {
  load = true;
};

const Spinner = () => {
  return (
    <>
      <div
        className={
          load ? "overlay h-screen w-full absolute top-0 left-0 z-50" : "hidden"
        }
        style={{ backgroundColor: "rgba(255,255,255,0.45)" }}
      >
        <div className="boxContainer w-full h-screen justify-center flex items-center">
          <LoadingOutlined
            className="text-teal-700"
            style={{ fontSize: 128 }}
            spin
          />
        </div>
      </div>
    </>
  );
};

export default Spinner;
